module.exports = __webpack_public_path__ + "static/media/uma_logo.55f8bebd.jpg";